import React from 'react';
import { Badge } from 'reactstrap';

const RowDetail = ({ row, filtersValuesMap, usageStore }) => {
  const preparedLinkedAccountsOptions = usageStore.getPreparedLinkedAccountsOptions(
    row.linkedAccounts,
    filtersValuesMap.get('linkedaccid'),
  );
  return (
    <div style={{ padding: '10px' }}>
      <ul style={{ display: 'flex', flexDirection: 'row', 'list-style-type': 'none' }}>
        {preparedLinkedAccountsOptions.map((la) => (
          <li key={la.label} style={{ padding: '2px' }}>
            <Badge color="light" pill style={{ border: 'solid 1px #70bbfd', background: '#fff' }}>
              <div style={{ padding: '2px', color: '#70bbfd' }}>
                <span>{la.label}</span>
              </div>
            </Badge>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RowDetail;
